<template>
  <div class="div_serach">
    <div class="search-txt-line fr">
      <dl class="clearfix">
        <dt>
          <input type="submit" @click="toSearch" class="search-submit-btn btn-search-input" value="" />
        </dt>
        <dd>
          <input
            type="text"
            id="txt_search"
            v-model="SearchItem"
            @keyup.enter="toSearch"
            @search="toSearch"
            placeholder="请输入您要搜索的内容"
            class="search-input-txt search-input"
          />
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      SearchItem: "",
    };
  },
  methods: {
    toSearch() {
      let val = this.SearchItem;
      if (this.$route.name == "todo") {
        this.$store.state.apiMap["todo"].query = val;
      } else if (this.$route.name == "appall") {
        this.$store.dispatch("manageApp/updateQuery", { seq: val?val:'all' });
      } else if (this.$route.name == "apps") {
        this.$store.dispatch("manageApp/updateQuery", { seq: val?val:'all' });
        this.$router.push("/workflow/appall");
      } else {
        this.$store.dispatch("SearchQ", {
          key: this.$route.name,
          property: "keyword",
          val,
        });
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/modules/Search.vue